import styled from 'styled-components';
import { colors, fontFamily, menuShadow } from '../../../Utils/tokens';

export const MenuContainer = styled.div`
  position: fixed;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  width: 208px;
  overflow: hidden;
  border: 1px solid ${colors.surfaceOutline};
  border-radius: 6px;
  background-color: ${colors.surface};
  box-shadow: ${menuShadow};
  font-family: ${fontFamily};
`;

export const MenuGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px;

  & + & {
    border-top: 1px solid ${colors.surfaceOutline};
  }
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 32px;
  padding: 6px;
  border: none;
  border-radius: 6px;
  background-color: ${colors.surface};
  cursor: pointer;
  text-align: left;

  img {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }

  span {
    flex: 1 0 0;
    min-width: 0;
    overflow: hidden;
    font-family: ${fontFamily};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: ${colors.onSurface};
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover,
  &:focus-visible {
    background-color: ${colors.surfaceContainer};
    outline: none;
  }
`;
